import { render } from "./PlaybookShared.vue?vue&type=template&id=b157e8d8"
import script from "./PlaybookShared.vue?vue&type=script&lang=js"
export * from "./PlaybookShared.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__